<template>
  <div 
    class="fts-file-content" 
    :class="[wrapperClass, fileContentClass]" 
    :style="wrapperStyle" 
    @mouseover="mouseHover = true" 
    @mouseleave="mouseHover = false"> 
    <!-- image -->
    <template v-if="fileType === 'image'">
      <img :src="processFileName(filePath)" @click="openLightbox">
      <div class="file-remove" @click.stop="removeFile" v-if="editable">
        <font-awesome-icon :icon="['fas', 'times']" />
      </div>
    </template>
    <!-- file -->
    <template v-else-if="fileType === 'file'">
      <div class="file-extension" :style="{ backgroundColor : fileColor }">{{fileExtension}}</div>
      <!-- file:image -->
      <a
        class="file-name"
        :href="processFileName(filePath)"
        target="_blank"
        @click.prevent="openLightbox"
        v-if="isImageFile"
      >
        {{fileNameWithoutExtension}}
      </a>
      <!-- file:default -->
      <a
        class="file-name"
        :href="processFileName(filePath)"
        target="_blank"
        v-else
      >
        {{fileNameWithoutExtension}}
      </a>
      <font-awesome-icon class="file-remove-action" :icon="['fas', 'times']" fixed-width @click.stop="removeFile" v-if="editable" />
    </template>
    <!-- attachment (image) -->
    <div class="atch-image-content" v-else-if="isImageFile" @click="openLightbox">
      <img :src="processFileName(filePath)">
    </div>
    <!-- attachment (file) -->
    <a class="atch-file-content" :href="processFileName(filePath)" target="_blank" v-else>
      <div class="atch-file-extension" >
        <i class="atch-file-extension__icon fts-icon-file"></i>
        <div class="atch-file-extension__name" :style="{ background: fileColor }">{{fileExtension}}</div>
      </div>
      <div class="file-info">
        <fts-tippy
          :content="fileName"
          :options="{ delay: [500 , 0] }"
          trigger-class="file-name"
          class="file-info__header"
        >
          <template #trigger>{{fileNameWithoutExtension}}</template>
        </fts-tippy>   
        <div class="file-size" v-if="getfileSize">{{getfileSize}}</div>
      </div>
      <div class="file-actions" v-if="mouseHover && downloadable">
        <a class="file-action" :href="`${processFileName(filePath)}?download=true`">
          <font-awesome-icon :icon="['fas', 'cloud-download-alt']" fixed-width  />  
        </a>
      </div>
    </a>
    <!-- attachment (image & file) action -->
    <template v-if="fileType !== 'image' && fileType !== 'file'">
      <!-- remove -->
      <div class="file-remove" @click.prevent="removeFile" v-if="editable" >
        <font-awesome-icon :icon="['fas', 'times']" />  
      </div>
      <!-- on progress -->
      <template v-if="fileProgress">
        <!-- progress percent -->
        <div class="file-progress">
          <div class="file-progress-bar" :style="{width: `${100 - fileProgress}%`}"></div>
          <div class="file-progress-percent" v-if="getProgressPercentage">
            {{getProgressPercentage}}%
          </div>
        </div>
        <!-- cancel upload -->
        <div class="file-remove" @click.prevent="cancelUpload" v-if="cancellable">
          <font-awesome-icon :icon="['fas', 'times']" />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import commons from "../../commons/commons"
import FTSTippy from "../FTSTippy";

export default {
  props: {
    // Global
    fileName: String,
    fileType: String,
    filePath: String,
    fileContentClass: String,
    fileActive: Boolean,
    fileProgress: String,
    fileSize: Number,
    editable: Boolean,
    cancellable: Boolean,
    downloadable: Boolean,
    // Image
    imageWidth: {
      type: Number,
      default: 100
    },
    imageHeight: {
      type: Number,
      default: 80
    },
    imageContain: Boolean,
  },
  components: {
    "fts-tippy": FTSTippy
  },
  data:() => ({
    mouseHover: false
  }),
  methods: {
    processFileName(path) {
      return path;
      // if(!path) 
      // let paths = path.split('/');
      // let filename = paths[paths.length - 1];
      // filename = filename.replace("%", "%25").replace("#", "%23").replace(",", "%2c").replace("'", "%27")
      // paths = paths.slice(0, paths.length - 1);
      // paths.push(filename);
      // return paths.join('/');
    },
    removeFile() {
      this.$emit("removeFile")
    },
    openLightbox() {
      this.$emit("openLightbox")
    },
    cancelUpload() {
      this.$emit("cancelUpload")
    },
  },
  computed: {
    wrapperClass() {
      let wrapperClass = "atch-file-wrapper"
      if (this.fileType === 'image') {
        wrapperClass = "image-content-wrapper"
        if (this.imageContain)
          wrapperClass += " contain"
      }
      else if (this.fileType === 'file')
        wrapperClass = "file-content-wrapper"
      else if (this.isImageFile)
        wrapperClass = "atch-image-wrapper"

      return wrapperClass
    },
    wrapperStyle() {
      if (this.fileType === 'image')
        return { 
          'height': `${this.imageHeight}px`,
          'width': `${this.imageWidth}px`
        } 
    },
    fileNameWithoutExtension() {
      return this.fileName ? this.fileName.replace(/(.*)\.[^.]+$/, "$1") : this.fileName
    },
    fileColor() {
      return commons.getFileColor(this.fileName)
    },
    fileExtension() {
      return commons.getFileExtension(this.fileName)
    },
    isImageFile() {
      return commons.isImageFile(this.fileName)
    },
    getfileSize() {
      if (this.fileSize && typeof this.fileSize == 'number') {
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(this.fileSize) / Math.log(k));
        return parseFloat((this.fileSize / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
      }
    },
    getProgressPercentage() {
      return this.fileProgress && Math.trunc(this.fileProgress);
    },
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

/* to-do CSS naming */
.fts-file-content {
  position: relative;
  &.file-content-wrapper {
    width: 200px;
    display: flex;
    align-items: center;
    padding: .375rem .575rem;
    border: 1px solid var(--fts-gray-3);
    .file-extension {
      margin-right: .375rem;
      padding: 2px 5px;
      border-radius: .175rem;
      background: var(--fts-gray-5);
      color: #fff;
      font-size: .575rem;
      white-space: nowrap;
    }
    .file-name {
      @include text-overflow-ellipsis;
      flex: 1;
      font-size: .75rem;
      text-decoration: none;
      color: var(--fts-text);
      &:hover {
        color: $primaryColor;
        cursor: pointer;
      }
    }
    .file-remove-action {
      margin-left: .375rem;
      font-size: .75rem;
      color: var(--fts-gray-5);
      &:hover {
        color: var(--fts-danger);
        cursor: pointer;
      }
    }
  }
  &.image-content-wrapper {
    position: relative;
    display: inline-flex;
    vertical-align: bottom;
    &.contain > img {
      object-fit: contain;
    }
    &:not(.contain) > img {
      object-fit: cover;
    }
    > img {
      @include user-select-none;
      height: 100%;
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }
  &.atch-image-wrapper {
    position: relative;
    .atch-image-content {
      min-width: 88px;
      position: relative;
      padding-top: 50px;
      overflow: hidden;
      cursor: zoom-in;
      > img {
        @include absolute-center-middle;
        max-width: 100px;
      }
    }
  }
  &.atch-file-wrapper {   
    height: 50px;
    width: 180px;
    max-width: 100%;
    padding: .375rem;
    border: 1px solid var(--fts-gray-3);
    background: var(--fts-background);
    .atch-file-content {
      @include flex-center-middle;
      position: relative;
      text-decoration: none;
    }
    .atch-file-extension {
      position: relative;
      margin-right: .375rem;
      .atch-file-extension__icon {
        font-size: 2.25rem;
        color: var(--fts-gray-5);
      }
      .atch-file-extension__name {
        width: 2.1rem;
        position: absolute;
        top: 62%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 2px 5px;
        border-radius: .175rem;
        text-align: center;
        font-size: .575rem;
        color: #fff;
        line-height: 1;
      }
    }
    .file-info {
      min-width: 0;
      flex: 1;
      .file-info__header {
        display: inline-flex;
        max-width: 100%;
      }
      .file-name {
        @include text-overflow-ellipsis;
        font-size: .75rem;
        font-weight: 500;
        color: var(--fts-text);
      }
      .file-size {
        margin-top: 2px;
        font-size: .675rem;
        font-weight: 300;
        color: var(--fts-gray-5);
      }
    }
    .file-actions {
      position: absolute;
      right: .375rem;
      display: flex;
      align-items: center;
      padding: .175rem;
      box-shadow: var(--fts-elevation-1);
      border-radius: .25rem;
      background: var(--fts-popover-background);
      .file-action {
        padding: .375rem;
        border-radius: inherit;
        font-size: .75rem;
        color: var(--fts-gray-5);
        &:hover {
          background: var(--fts-gray-2);
          color: var(--fts-gray-5);
          cursor: pointer;
        }
      }
    }
  }
  .file-progress {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: row-reverse;
    .file-progress-bar {
      height: 100%;
      background: rgba($color: #000, $alpha: .65);
      transition: width .3s;
    }
    .file-progress-percent {
      position: absolute;
      bottom: 0;
      width: 100%;
      padding: .275rem;
      font-size: .75rem;
      text-align: center;
      color: #fff;
      background: rgba($color: #000, $alpha: .25);
    }
  }
  .file-remove {
    @include flex-center-middle;
    position: absolute;
    top: 2px;
    right: 2px;
    height: 20px;
    width: 20px;
    border-radius: 10em;
    background: var(--fts-gray-5);
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.16), 0 5px 15px 0 rgba(0, 0, 0, 0.12);
    color: #fff;
    cursor: pointer;
    &:hover {
      background: var(--fts-danger);
    }
    svg {
      font-size: .75rem;
    }
  }
}
</style>